import React, { Fragment } from "react"

import DetailedExplanationItem, { DirectionType } from "~/components/molecules/DetailedExplanationItem"
import HeadingSecondary from "~/components/molecules/HeadingSecondary"

interface Props {
  items: item[]
  heading: string
  direction: keyof typeof DirectionType
}

interface item {
  heading: string
  description: any
}

const DetailedExplanationList = ({ heading, items, direction }: Props) => {
  return (
    <>
      <HeadingSecondary>{heading}</HeadingSecondary>
      <div>
        {items.map((item: item, index) => {
          return (
            // NOTE: <>と<Fragment>は全く同じだが、<Fragment>でないとkeyを指定できない
            <Fragment key={index}>
              {item.description && (
                <DetailedExplanationItem heading={item.heading} direction={direction} key={index}>
                  {item.description}
                </DetailedExplanationItem>
              )}
            </Fragment>
          )
        })}
      </div>
    </>
  )
}

export default DetailedExplanationList
